import { MapPin, Home, Navigation, Hash, CreditCard, AlertTriangle, Tag } from "lucide-react";
import * as S from "./styles";

export const OrderAddress = ({ order }) => {
  if (!order.address_street) {
    return (
      <S.PickupBadge>
        <Home size={18} /> RETIRADA NO BALCÃO
      </S.PickupBadge>
    );
  }

  return (
    <S.AddressContainer>
      <S.MainAddressLine>
        <MapPin size={20} color="#ef4444" />
        <div className="street-info">
          <strong>{order.address_street}</strong>
          <span>Número: {order.address_number}</span>
        </div>
      </S.MainAddressLine>

      <S.SecondaryInfo>
        <Navigation size={14} />
        <span>Bairro: <strong>{order.address_neighborhood}</strong></span>
        {order.cep && <small> • {order.cep}</small>}
      </S.SecondaryInfo>

      {order.address_complement && (
        <S.ComplementBox>
          <Hash size={14} />
          <span>{order.address_complement}</span>
        </S.ComplementBox>
      )}
    </S.AddressContainer>
  );
};

export const OrderExtraInfo = ({ order }) => {
  return (
    <S.ExtraInfoContainer>
      <S.PaymentRow>
        <CreditCard size={16} />
        <span className="label">Pagamento:</span>
        <span>{order.payment_method}</span>
        {order.change_details && (
          <span className="change">(Troco: {order.change_details})</span>
        )}
      </S.PaymentRow>

      {order.coupon_code && (
        <S.PaymentRow>
          <Tag size={16} />
          <span className="label">Cupom:</span>
          <span>
            {order.coupon_code} (−{" "}
            {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(order.discount || 0)})
          </span>
        </S.PaymentRow>
      )}

      {order.notes && order.notes !== 'Sem observações' && (
        <S.ObservationBox>
          <AlertTriangle size={16} />
          <div>
            <strong>OBSERVAÇÃO:</strong> {order.notes}
          </div>
        </S.ObservationBox>
      )}
    </S.ExtraInfoContainer>
  );
};

/** O que o cliente tirou ou pediu a mais no lanche (ou as camadas do "Monte seu Lanche"). */
export const ItemCustomizations = ({ item }) => {
  const list = item.customizations || [];
  if (list.length === 0 && !item.notes) return null;
  const unit = (c) => (c.quantity > 1 ? `${c.quantity}x ${c.name}` : c.name);

  return (
    <S.Customizations>
      {item.is_builder ? (
        <span className="composition">{list.map(unit).join(", ")}</span>
      ) : (
        <>
          {list.filter((c) => c.kind === "removed").length > 0 && (
            <span className="removed">
              Sem {list.filter((c) => c.kind === "removed").map((c) => c.name).join(", ")}
            </span>
          )}
          {list
            .filter((c) => c.kind === "added")
            .map((c) => (
              <span key={c.name} className="added">
                +{c.quantity} {c.name}
              </span>
            ))}
        </>
      )}
      {item.notes && <span className="note">“{item.notes}”</span>}
    </S.Customizations>
  );
};

export const OrderTotal = ({ value }) => {
  const formatted = new Intl.NumberFormat('pt-BR', { 
    style: 'currency', 
    currency: 'BRL' 
  }).format(value || 0);

  return (
    <S.TotalContainer>
      <span>TOTAL DO PEDIDO</span>
      <strong>{formatted}</strong>
    </S.TotalContainer>
  );
};